var p={pointer:"lds-tip-pointer--pointer",pulse:"lds-tip-pointer--pulse"};export{p as default};
